import React from 'react';
import './TransportTypeSelector.css';

const TRANSPORT_TYPES = [
  { id: 'vuelo', icon: '✈️', label: 'Vuelo', color: '#3b82f6' },
  { id: 'tren', icon: '🚂', label: 'Tren', color: '#10b981' },
  { id: 'bus', icon: '🚌', label: 'Bus', color: '#f59e0b' }
];

const TransportTypeSelector = ({ value, onChange }) => {
  return (
    <div className="transport-type-selector">
      {TRANSPORT_TYPES.map((type) => (
        <button
          key={type.id}
          type="button"
          className={`transport-type-btn ${value === type.id ? 'active' : ''}`}
          onClick={() => onChange(type.id)}
          title={type.label}
          style={{
            '--type-color': type.color
          }}
        >
          <span className="transport-icon">{type.icon}</span>
          <span className="transport-label">{type.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TransportTypeSelector;

